<app-header-one [sticky]="true" *ngIf="url != '/pages/comingsoon'" #TopHeader></app-header-one>
<div [ngStyle]="{'margin-top': height}">
<router-outlet></router-outlet>
</div>
<app-footer-one *ngIf="url != '/pages/comingsoon'"></app-footer-one>
